import { TranslateResult } from 'vue-i18n';
import { TRACKING_EVENT_LABEL } from '../../models/constants';
// enums
enum BottomRowButtonAction {
  MODAL = 'MODAL',
  LINK = 'LINK',
}

enum BottomRowButtonTarget {
  BLANK = '_blank',
  CANCELLATION = 'cancellation',
  RESCHEDULE = 'reschedule',
}

// interfaces
interface BottomRowButton {
  label: TranslateResult | string;
  icon?: string;
  variant: string;
  action?: BottomRowButtonAction;
  link?: string;
  target?: string;
  trackingLabel?: TRACKING_EVENT_LABEL;
}

interface BottomRowInformation {
  key?: number;
  label: string;
  order?: number;
  icon: string;
  link: string;
  variant?: string;
}

interface InformationCard {
  unfinished: {
    booking: InformationCardStructure;
    request: InformationCardStructure;
  };
  finished: {
    cancelled: InformationCardStructure;
    done: InformationCardStructure;
  };
}

interface InformationCardStructure {
  date: string;
  time: string;
  tag: string;
  tagVariant?: string;
  bookingId: string;
  tooltipText?: string;
  disabled?: boolean;
  collapsible?: boolean;
  additionalInfo?: StandardInformation;
  requestCancellation?: StandardInformation;
  bottomRowButtons?: BottomRowButton[];
}

interface StandardInformation {
  title: string;
  message: string;
}

interface StandardRowInformation {
  date: string;
  time: string;
  tag: string;
  bookingId: string;
  tooltipText?: string;
}

// returning types for classes
interface CollapsedCard {
  'information-card--collapsed': boolean;
}

interface DisabledBookingId {
  'disabled-class--booking-id': boolean;
}

interface DisabledLineThrough {
  'disabled-class--line-through': boolean;
  'disabled-class--line-through-rtl': boolean;
}

interface DisabledMiddleRow {
  'disabled-class': boolean;
}

interface TagStyles {
  'information-card__top-row--tag-cancelled-or-request': boolean;
  'information-card__top-row--tag-done': boolean;
}

// returning types for styles
interface CollapsibleHeight {
  maxHeight?: string;
}

export {
  // enums
  BottomRowButtonAction,
  BottomRowButtonTarget,
  // interfaces
  BottomRowButton,
  BottomRowInformation,
  InformationCard,
  InformationCardStructure,
  StandardInformation,
  StandardRowInformation,
  // returning types for classes
  CollapsedCard,
  DisabledBookingId,
  DisabledLineThrough,
  DisabledMiddleRow,
  TagStyles,
  // returning types for styles
  CollapsibleHeight,
};
